import { render } from "./IconEmoji.vue?vue&type=template&id=0f1a92c5&scoped=true"
import script from "./IconEmoji.vue?vue&type=script&lang=js"
export * from "./IconEmoji.vue?vue&type=script&lang=js"

import "./IconEmoji.vue?vue&type=style&index=0&id=0f1a92c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1a92c5"]])

export default __exports__